/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it
import "./src/styles/global.scss";

import ReactDOM from "react-dom/client";

export const replaceHydrateFunction = () => {
  return (element, container) => {
    const root = ReactDOM.createRoot(container);
    root.render(element);
  };
};

export const onRouteUpdate = ({ location }) => {
  if (location.pathname === "/download") {
    window.location.replace = "/download/index.html";
  }
};

//* here are the available routes
// 1. /
// 1.1 /tr/
// 2. /download

// 3. /terms-of-use
// 3.1 /tr/terms-of-use
// 4. /terms-of-use/?inapp=true
// 4.1 /tr/terms-of-use/?inapp=true

// 5. /privacy-policy
// 5.1 /tr/privacy-policy
// 6. /privacy-policy/?inapp=true
// 6.1 /tr/privacy-policy/?inapp=true

export const onClientEntry = () => {
  const languageFromStorage = localStorage.getItem("gatsby-i18next-language");
  const browserLanguage = navigator.language;
  const shortBrowserLang = browserLanguage.split("-")[0];

  const siteUrl = process.env.GATSBY_SITE_URL;
  const basePath = new URL(siteUrl).pathname;
  const currentPath = window.location.pathname;

  function getRelativePath(path, base) {
    if (path.startsWith(base)) {
      const relative = path.slice(base.length);
      return relative.startsWith("/") ? relative : "/" + relative;
    }
    return path;
  }

  const relativePath = getRelativePath(currentPath, basePath);

  // en language selected
  // {
  // basePath: "/self/";
  // browserLanguage: "en";
  // currentPath: "/";
  // languageFromStorage: "en";
  // shortBrowserLang: "en";
  // siteUrl: "http://localhost:8000/self/";
  // relativePath: "/";
  // }

  // tr language selected
  //   {
  // basePath: "/self/";
  // browserLanguage: "en";
  // currentPath: "/tr/";
  // languageFromStorage: "tr";
  // shortBrowserLang: "en";
  // siteUrl: "http://localhost:8000/self/";
  // relativePath: "/tr/"
  // }

  if (relativePath === "/" || relativePath === "") {
    if (
      (languageFromStorage && languageFromStorage === "tr") ||
      (!languageFromStorage && shortBrowserLang === "tr")
    ) {
      window.location.replace(`${siteUrl}tr/`);
    }
  } else if (relativePath.includes("terms-of-use") || relativePath.includes("privacy-policy")) {
    if (
      (languageFromStorage && languageFromStorage === "tr") ||
      (!languageFromStorage && shortBrowserLang === "tr")
    ) {
      if (!relativePath.startsWith("/tr")) {
        window.location.replace(`${siteUrl}tr${relativePath}`);
      }
    }
  }
};
